import { Component, ElementRef, ViewChild } from '@angular/core';
import { WatchAwareComponent } from '../watch-aware.component';
import { Dice } from '../../util/dice';
import { Room } from 'src/sync/room';
import { Account } from 'src/sync/account';
import { Kb } from 'src/util/kb';
import { Util } from 'src/util/util';
import { Store } from 'src/sync/store';

@Component({
    selector: 'app-dicemacro',
    templateUrl: './dicemacro.component.html',
    styleUrls: ['./dicemacro.component.scss'],
    standalone: false
})
export class DicemacroComponent extends WatchAwareComponent {
    @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

    public newTarget = -1;
    public macroText: string = '';
    public macros: string[] = [];
    public keySubscription = Kb.on({ code: 'KeyN' }, () => this.createOrEdit(this.macros.length));
    public dragSource = -1;
    public dragTarget = -1;
    public opaque = Account.settings.get().opaquemacros;

    public ngAfterViewInit() {
        this.track(Account.settings.watch((x) => this.macros = x.dicemacros));
        this.track(Account.settings.watch((x) => this.opaque = x.opaquemacros));
    }

    public delete(index: number) {
        const macros = Util.clone(this.macros);
        macros.splice(index, 1);
        this.macros = macros;
        Account.settings.modify(x => x.dicemacros = macros);
    }

    public createOrEdit(index: number) {
        if (index == this.macros.length) {
            this.macros.push('');
        }

        this.newTarget = index;
        this.macroText = this.macros[index];

        const save = () => {
            const result = Dice.roll(this.macroText);

            if (result) {
                this.macros[this.newTarget] = this.macroText;
                Account.settings.modify(x => x.dicemacros = Util.clone(this.macros));
            } else {
                this.delete(index);
            }

            this.newTarget = -1;

            setTimeout(() => (document.activeElement as HTMLElement)?.blur());
        }

        setTimeout(() => {
            this.inputElement.nativeElement.focus();
            this.inputElement.nativeElement.addEventListener('keydown', (e) => {
                if (Util.isAffirmativeKey(e)) {
                    this.inputElement.nativeElement.blur();
                } else if (e.code == 'Escape') {
                    const isNotNew = this.newTarget != this.macros.length
                    if (isNotNew && this.macroText == '') {
                        this.macroText = this.macros[this.newTarget];
                    }
                    this.inputElement.nativeElement.blur();
                }
                e.stopPropagation();
            });
            this.inputElement.nativeElement.addEventListener('blur', save);
        });
    }

    public roll(input: string) {
        Store.playDicerollSFX();
        Room.shout(input, Store.chatmode);
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
        this.keySubscription.unsubscribe();
    }

    public dragstart(e: DragEvent) {
        const el = (e.target as HTMLElement);
        el.classList.add('dragging');
        setTimeout(() => el.classList.remove('dragging'));

        this.dragSource = parseInt(el.getAttribute('index') || '-1');
    }

    public dragenter(e: DragEvent) {
        const el = (e.target as HTMLElement);
        el.classList.add('over');
        this.dragTarget = parseInt(el.getAttribute('index') || '-1');
    }

    public dragleave(e: DragEvent) {
        const el = (e.target as HTMLElement);
        el.classList.remove('over');
        this.dragTarget = -1;
    }

    public dragend(e: DragEvent) {
        document.querySelectorAll('.dicemacro').forEach((el) => {
            el.classList.remove('over');
        });

        if (this.dragSource != -1 && this.dragTarget != -1) {
            Util.arrayMove(this.macros, this.dragSource, this.dragTarget);
            Account.settings.modify(x => x.dicemacros = Util.clone(this.macros));
        }

        this.dragTarget = -1;
    }
}
